/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShipmentShowHomeContentQueryVariables = {
    slug: string;
};
export type ShipmentShowHomeContentQueryResponse = {
    readonly shipmentShow: {
        readonly slug: string;
        readonly draftContacts: {
            readonly " $fragmentRefs": FragmentRefs<"LinkedContactsCard_draftContacts">;
        };
        readonly linkedContactRoles: {
            readonly " $fragmentRefs": FragmentRefs<"LinkedContactsCard_linkedContactRoles">;
        };
        readonly liveShares: {
            readonly " $fragmentRefs": FragmentRefs<"LiveShare_liveShares">;
        };
        readonly liveRequests: {
            readonly " $fragmentRefs": FragmentRefs<"LiveRequest_liveRequests">;
        };
        readonly emails: {
            readonly " $fragmentRefs": FragmentRefs<"EmailsCard_emails">;
        };
        readonly messages: {
            readonly " $fragmentRefs": FragmentRefs<"MessagesCard_messages">;
        };
        readonly folders: {
            readonly " $fragmentRefs": FragmentRefs<"FoldersCard_folders" | "UploadDocumentsWizard_folders">;
        };
        readonly " $fragmentRefs": FragmentRefs<"ShipmentFinanceCard_shipment" | "ShipmentInfoCard_shipment" | "VinDetailsCard_shipment" | "ShipmentCompanyCard_shipment" | "ShipmentFinanceMetricCard_shipment" | "UploadDocumentsWizard_shipment">;
    };
};
export type ShipmentShowHomeContentQuery = {
    readonly response: ShipmentShowHomeContentQueryResponse;
    readonly variables: ShipmentShowHomeContentQueryVariables;
};



/*
query ShipmentShowHomeContentQuery(
  $slug: String!
) {
  shipmentShow(slug: $slug) {
    slug
    ...ShipmentFinanceCard_shipment
    ...ShipmentInfoCard_shipment
    ...VinDetailsCard_shipment
    ...ShipmentCompanyCard_shipment
    ...ShipmentFinanceMetricCard_shipment
    ...UploadDocumentsWizard_shipment
    draftContacts {
      ...LinkedContactsCard_draftContacts
    }
    linkedContactRoles {
      ...LinkedContactsCard_linkedContactRoles
    }
    liveShares {
      ...LiveShare_liveShares
    }
    liveRequests {
      ...LiveRequest_liveRequests
    }
    emails {
      ...EmailsCard_emails
    }
    messages {
      ...MessagesCard_messages
    }
    folders {
      ...FoldersCard_folders
      ...UploadDocumentsWizard_folders
    }
    id
  }
}

fragment Attachment_attachment on Attachment {
  url
  name
  contentType
  previewUrl
}

fragment EmailItem_email on Email {
  slug
  subject
  from
  to
  body
  sentAt
  attachments {
    name
    ...SmallAttachment_attachment
    ...Attachment_attachment
  }
}

fragment EmailsCard_emails on EmailConnection {
  nodes {
    slug
    ...EmailItem_email
    id
  }
}

fragment EntityAttachmentListItem_attachment on EntityAttachment {
  url
  downloadUrl
  name
  contentType
  previewUrl
  documentType
  roleVisibilities {
    role
    roleShortTitle
    roleTitle
    visible
  }
  uploadedAtDisplay
  uploadedAt
}

fragment EntityAttachmentListPreviewer_attachment on EntityAttachment {
  url
  downloadUrl
  name
  contentType
  previewUrl
  documentType
  entityType
  entitySlug
  attachmentSlug
  thumbnailImage
  ...EntityAttachmentRoleVisibility_attachment
}

fragment EntityAttachmentRoleVisibility_attachment on EntityAttachment {
  name
  attachmentSlug
  entityType
  entitySlug
  roleVisibilities {
    role
    roleShortTitle
    roleTitle
    visible
  }
}

fragment EntityAttachment_attachment on EntityAttachment {
  url
  downloadUrl
  name
  contentType
  previewUrl
  documentType
  draftTicketStatus
  lexOfficeInvoiceStatus
  signedStatus
  rejectReason
}

fragment FileCreationDialog_folder on Folder {
  slug
  name
}

fragment Folder_folder on Folder {
  slug
  name
  parentType
  entitySlug
  attachments {
    attachmentSlug
    name
    ...EntityAttachmentListPreviewer_attachment
    ...EntityAttachment_attachment
    ...EntityAttachmentListItem_attachment
    id
  }
  ...FileCreationDialog_folder
}

fragment FoldersCard_folders on FolderConnection {
  nodes {
    slug
    parentType
    ...Folder_folder
    id
  }
}

fragment LinkedContactsCard_draftContacts on DraftContactConnection {
  nodes {
    slug
    name
    displayRoles
    image {
      url
      alt
    }
    id
  }
}

fragment LinkedContactsCard_linkedContactRoles on ContactLinkRoleConnection {
  nodes {
    role
    contactLink {
      displayRole
      displayName
      contactItem {
        slug
        title
        image {
          url
          alt
        }
        id
      }
    }
  }
}

fragment LiveRequest_liveRequests on TicketConnection {
  nodes {
    slug
    title
    status
    direction
    ticketType
    absoluteSlugs
    raisedAt
    displayStatus
    raisedBy {
      name
      id
    }
    raisedFor {
      name
      id
    }
    id
  }
}

fragment LiveShareDrawer_liveshare on LiveShare {
  name
  slug
  password
  url
  contact {
    firstName
    lastName
    email
    id
  }
  email
  generatedBy
  generatedAt
  requestedBy
  requestedAt
  viewedAt
  expiresAt
}

fragment LiveShare_liveShares on LiveShareConnection {
  nodes {
    name
    slug
    password
    url
    contact {
      firstName
      lastName
      email
      id
    }
    email
    expiresAt
    generatedBy
    generatedAt
    requestedBy
    requestedAt
    expired
    ...LiveShareDrawer_liveshare
    id
  }
}

fragment MessageItem_message on Message {
  slug
  subject
  from
  to
  body
  sentAt
  attachments {
    name
    ...SmallAttachment_attachment
    ...Attachment_attachment
  }
}

fragment MessagesCard_messages on MessageConnection {
  nodes {
    slug
    ...MessageItem_message
  }
}

fragment ShipmentCompanyCard_shipment on Shipment {
  slug
  company {
    eori
    eoriValid
    eoriValidatedAt
    vat
    vatValid
    vatValidatedAt
    id
  }
  eoriDocGeneratedAt
  vatDocGeneratedAt
}

fragment ShipmentFinanceCard_shipment on Shipment {
  slug
  revenueOpinion
  totalRevenue
  totalCost
  finances {
    label
    value
  }
}

fragment ShipmentFinanceMetricCard_shipment on Shipment {
  slug
  totalCost
  totalRevenue
  totalProfit
  shipmentTypeDetails {
    vatChargePercent
  }
  estimatedRevenueWarehousing
  vatCalculator
  lexofficeInvoiceAmountPaid
}

fragment ShipmentInfoCard_shipment on Shipment {
  slug
  stage
  shipmentValueCurrency
  shipmentCostCurrency
  customsClearanceInfoText
  customerName
  customerAddress
  customerState
  customerPostcode
  customerPlace
  customerCountry
  customerPhone
  customerCompany
  customerFormat
  containerSlug
  requiredDocuments
  deliveryLocation
  infoGroupedByStage {
    stageLabel
    stageValue
    fields {
      label
      name
      value
    }
  }
}

fragment SmallAttachment_attachment on Attachment {
  url
  name
  contentType
  previewUrl
}

fragment UploadDocumentsWizard_folders on FolderConnection {
  nodes {
    slug
    activeTicket
    parentType
    attachments {
      id
      documentType
    }
    id
  }
}

fragment UploadDocumentsWizard_shipment on Shipment {
  slug
  requiredDocuments
}

fragment VinDetailsCard_shipment on Shipment {
  slug
  vinDetails {
    label
    name
    value
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v3/*: any*/),
  (v5/*: any*/),
  (v4/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v13 = [
  (v5/*: any*/),
  (v7/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subject",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "from",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "to",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previewUrl",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "attachments",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v8/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entitySlug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShipmentShowHomeContentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Shipment",
        "kind": "LinkedField",
        "name": "shipmentShow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftContactConnection",
            "kind": "LinkedField",
            "name": "draftContacts",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LinkedContactsCard_draftContacts"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactLinkRoleConnection",
            "kind": "LinkedField",
            "name": "linkedContactRoles",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LinkedContactsCard_linkedContactRoles"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LiveShareConnection",
            "kind": "LinkedField",
            "name": "liveShares",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LiveShare_liveShares"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketConnection",
            "kind": "LinkedField",
            "name": "liveRequests",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LiveRequest_liveRequests"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailConnection",
            "kind": "LinkedField",
            "name": "emails",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EmailsCard_emails"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageConnection",
            "kind": "LinkedField",
            "name": "messages",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MessagesCard_messages"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FolderConnection",
            "kind": "LinkedField",
            "name": "folders",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FoldersCard_folders"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UploadDocumentsWizard_folders"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShipmentFinanceCard_shipment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShipmentInfoCard_shipment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VinDetailsCard_shipment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShipmentCompanyCard_shipment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShipmentFinanceMetricCard_shipment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UploadDocumentsWizard_shipment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShipmentShowHomeContentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Shipment",
        "kind": "LinkedField",
        "name": "shipmentShow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueOpinion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalRevenue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCost",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyValueField",
            "kind": "LinkedField",
            "name": "finances",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shipmentValueCurrency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shipmentCostCurrency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customsClearanceInfoText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerState",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerPostcode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerPlace",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerCountry",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerPhone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerCompany",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerFormat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "containerSlug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requiredDocuments",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deliveryLocation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InfoGroup",
            "kind": "LinkedField",
            "name": "infoGroupedByStage",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stageLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stageValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InfoField",
                "kind": "LinkedField",
                "name": "fields",
                "plural": true,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InfoField",
            "kind": "LinkedField",
            "name": "vinDetails",
            "plural": true,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eori",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eoriValid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eoriValidatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatValid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatValidatedAt",
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eoriDocGeneratedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vatDocGeneratedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalProfit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ShipmentTypeDetails",
            "kind": "LinkedField",
            "name": "shipmentTypeDetails",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatChargePercent",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimatedRevenueWarehousing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vatCalculator",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lexofficeInvoiceAmountPaid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftContactConnection",
            "kind": "LinkedField",
            "name": "draftContacts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DraftContact",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayRoles",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactLinkRoleConnection",
            "kind": "LinkedField",
            "name": "linkedContactRoles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactLinkRole",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactLink",
                    "kind": "LinkedField",
                    "name": "contactLink",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayRole",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ListItem",
                        "kind": "LinkedField",
                        "name": "contactItem",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v11/*: any*/),
                          (v9/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LiveShareConnection",
            "kind": "LinkedField",
            "name": "liveShares",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LiveShare",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "password",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Contact",
                    "kind": "LinkedField",
                    "name": "contact",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expiresAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "generatedBy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "generatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requestedBy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requestedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expired",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewedAt",
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketConnection",
            "kind": "LinkedField",
            "name": "liveRequests",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Ticket",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "direction",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ticketType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "absoluteSlugs",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "raisedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Contact",
                    "kind": "LinkedField",
                    "name": "raisedBy",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Contact",
                    "kind": "LinkedField",
                    "name": "raisedFor",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailConnection",
            "kind": "LinkedField",
            "name": "emails",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Email",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v21/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageConnection",
            "kind": "LinkedField",
            "name": "messages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Message",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FolderConnection",
            "kind": "LinkedField",
            "name": "folders",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Folder",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentType",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EntityAttachment",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attachmentSlug",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "downloadUrl",
                        "storageKey": null
                      },
                      (v19/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "documentType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "entityType",
                        "storageKey": null
                      },
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "thumbnailImage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleVisibility",
                        "kind": "LinkedField",
                        "name": "roleVisibilities",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roleShortTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "roleTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "visible",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "draftTicketStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lexOfficeInvoiceStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "signedStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rejectReason",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "uploadedAtDisplay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "uploadedAt",
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeTicket",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cc55c39b2673d0798d02283fcfd886ed",
    "id": null,
    "metadata": {},
    "name": "ShipmentShowHomeContentQuery",
    "operationKind": "query",
    "text": "query ShipmentShowHomeContentQuery(\n  $slug: String!\n) {\n  shipmentShow(slug: $slug) {\n    slug\n    ...ShipmentFinanceCard_shipment\n    ...ShipmentInfoCard_shipment\n    ...VinDetailsCard_shipment\n    ...ShipmentCompanyCard_shipment\n    ...ShipmentFinanceMetricCard_shipment\n    ...UploadDocumentsWizard_shipment\n    draftContacts {\n      ...LinkedContactsCard_draftContacts\n    }\n    linkedContactRoles {\n      ...LinkedContactsCard_linkedContactRoles\n    }\n    liveShares {\n      ...LiveShare_liveShares\n    }\n    liveRequests {\n      ...LiveRequest_liveRequests\n    }\n    emails {\n      ...EmailsCard_emails\n    }\n    messages {\n      ...MessagesCard_messages\n    }\n    folders {\n      ...FoldersCard_folders\n      ...UploadDocumentsWizard_folders\n    }\n    id\n  }\n}\n\nfragment Attachment_attachment on Attachment {\n  url\n  name\n  contentType\n  previewUrl\n}\n\nfragment EmailItem_email on Email {\n  slug\n  subject\n  from\n  to\n  body\n  sentAt\n  attachments {\n    name\n    ...SmallAttachment_attachment\n    ...Attachment_attachment\n  }\n}\n\nfragment EmailsCard_emails on EmailConnection {\n  nodes {\n    slug\n    ...EmailItem_email\n    id\n  }\n}\n\nfragment EntityAttachmentListItem_attachment on EntityAttachment {\n  url\n  downloadUrl\n  name\n  contentType\n  previewUrl\n  documentType\n  roleVisibilities {\n    role\n    roleShortTitle\n    roleTitle\n    visible\n  }\n  uploadedAtDisplay\n  uploadedAt\n}\n\nfragment EntityAttachmentListPreviewer_attachment on EntityAttachment {\n  url\n  downloadUrl\n  name\n  contentType\n  previewUrl\n  documentType\n  entityType\n  entitySlug\n  attachmentSlug\n  thumbnailImage\n  ...EntityAttachmentRoleVisibility_attachment\n}\n\nfragment EntityAttachmentRoleVisibility_attachment on EntityAttachment {\n  name\n  attachmentSlug\n  entityType\n  entitySlug\n  roleVisibilities {\n    role\n    roleShortTitle\n    roleTitle\n    visible\n  }\n}\n\nfragment EntityAttachment_attachment on EntityAttachment {\n  url\n  downloadUrl\n  name\n  contentType\n  previewUrl\n  documentType\n  draftTicketStatus\n  lexOfficeInvoiceStatus\n  signedStatus\n  rejectReason\n}\n\nfragment FileCreationDialog_folder on Folder {\n  slug\n  name\n}\n\nfragment Folder_folder on Folder {\n  slug\n  name\n  parentType\n  entitySlug\n  attachments {\n    attachmentSlug\n    name\n    ...EntityAttachmentListPreviewer_attachment\n    ...EntityAttachment_attachment\n    ...EntityAttachmentListItem_attachment\n    id\n  }\n  ...FileCreationDialog_folder\n}\n\nfragment FoldersCard_folders on FolderConnection {\n  nodes {\n    slug\n    parentType\n    ...Folder_folder\n    id\n  }\n}\n\nfragment LinkedContactsCard_draftContacts on DraftContactConnection {\n  nodes {\n    slug\n    name\n    displayRoles\n    image {\n      url\n      alt\n    }\n    id\n  }\n}\n\nfragment LinkedContactsCard_linkedContactRoles on ContactLinkRoleConnection {\n  nodes {\n    role\n    contactLink {\n      displayRole\n      displayName\n      contactItem {\n        slug\n        title\n        image {\n          url\n          alt\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment LiveRequest_liveRequests on TicketConnection {\n  nodes {\n    slug\n    title\n    status\n    direction\n    ticketType\n    absoluteSlugs\n    raisedAt\n    displayStatus\n    raisedBy {\n      name\n      id\n    }\n    raisedFor {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment LiveShareDrawer_liveshare on LiveShare {\n  name\n  slug\n  password\n  url\n  contact {\n    firstName\n    lastName\n    email\n    id\n  }\n  email\n  generatedBy\n  generatedAt\n  requestedBy\n  requestedAt\n  viewedAt\n  expiresAt\n}\n\nfragment LiveShare_liveShares on LiveShareConnection {\n  nodes {\n    name\n    slug\n    password\n    url\n    contact {\n      firstName\n      lastName\n      email\n      id\n    }\n    email\n    expiresAt\n    generatedBy\n    generatedAt\n    requestedBy\n    requestedAt\n    expired\n    ...LiveShareDrawer_liveshare\n    id\n  }\n}\n\nfragment MessageItem_message on Message {\n  slug\n  subject\n  from\n  to\n  body\n  sentAt\n  attachments {\n    name\n    ...SmallAttachment_attachment\n    ...Attachment_attachment\n  }\n}\n\nfragment MessagesCard_messages on MessageConnection {\n  nodes {\n    slug\n    ...MessageItem_message\n  }\n}\n\nfragment ShipmentCompanyCard_shipment on Shipment {\n  slug\n  company {\n    eori\n    eoriValid\n    eoriValidatedAt\n    vat\n    vatValid\n    vatValidatedAt\n    id\n  }\n  eoriDocGeneratedAt\n  vatDocGeneratedAt\n}\n\nfragment ShipmentFinanceCard_shipment on Shipment {\n  slug\n  revenueOpinion\n  totalRevenue\n  totalCost\n  finances {\n    label\n    value\n  }\n}\n\nfragment ShipmentFinanceMetricCard_shipment on Shipment {\n  slug\n  totalCost\n  totalRevenue\n  totalProfit\n  shipmentTypeDetails {\n    vatChargePercent\n  }\n  estimatedRevenueWarehousing\n  vatCalculator\n  lexofficeInvoiceAmountPaid\n}\n\nfragment ShipmentInfoCard_shipment on Shipment {\n  slug\n  stage\n  shipmentValueCurrency\n  shipmentCostCurrency\n  customsClearanceInfoText\n  customerName\n  customerAddress\n  customerState\n  customerPostcode\n  customerPlace\n  customerCountry\n  customerPhone\n  customerCompany\n  customerFormat\n  containerSlug\n  requiredDocuments\n  deliveryLocation\n  infoGroupedByStage {\n    stageLabel\n    stageValue\n    fields {\n      label\n      name\n      value\n    }\n  }\n}\n\nfragment SmallAttachment_attachment on Attachment {\n  url\n  name\n  contentType\n  previewUrl\n}\n\nfragment UploadDocumentsWizard_folders on FolderConnection {\n  nodes {\n    slug\n    activeTicket\n    parentType\n    attachments {\n      id\n      documentType\n    }\n    id\n  }\n}\n\nfragment UploadDocumentsWizard_shipment on Shipment {\n  slug\n  requiredDocuments\n}\n\nfragment VinDetailsCard_shipment on Shipment {\n  slug\n  vinDetails {\n    label\n    name\n    value\n  }\n}\n"
  }
};
})();
(node as any).hash = 'abc274563634d705b6148b9703f355b9';
export default node;
